export const dateRenderer = (_instance, td, _row, _col, _prop, value) => {
  if (value == null || !value) {
    td.innerHTML = `<div class="truncated"></div>`;
    return td;
  }

  let date;

  if (typeof value === "string" && !value.includes("T")) {
    // If value is a string without a time component, append T00:00:00
    date = new Date(value + "T00:00:00");
  } else {
    // If value already has a time/timezone or is a Date object, use it directly
    date = new Date(value);
  }

  const output = date.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "2-digit",
  });

  td.innerHTML = `<div class="truncated">${output}</div>`;

  return td;
};
